import { useState, useEffect} from 'react';

export function useScrollToTop() {

    // funcinalidad para boton scroll to top
    const [subirVisible, setSubirVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 200) {
            setSubirVisible(true);
        } else {
            setSubirVisible(false);
        }
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
    }, []);

    return {subirVisible, scrollToTop};
}